module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_an-ff1a4e510518e09215d0d83497fcc266.svg";